import { Alert, Card, Spin, Typography, InputNumber, Button, Form, message } from "antd";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { receiptAPIWithErrorHandling } from "../../../api/receipt/receipt";
import { DownloadOutlined, HeartOutlined } from "@ant-design/icons";


const { Title, Text, Paragraph } = Typography;

const CampainCustomer = () => {
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [receiptData, setReceipt] = useState(null);
    const [showAmountForm, setShowAmountForm] = useState(true);
    const [generatingQR, setGeneratingQR] = useState(false);
    const [amount, setAmount] = useState(null);

    const code = searchParams.get("code");

    useEffect(() => {
        const loadPDF = async () => {
            try {
                const response = await receiptAPIWithErrorHandling.getCampain(code);
                setReceipt(response.data);
            } catch (err) {
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        if (code) loadPDF();
    }, [code]);

    const handleGenerateQR = async (values) => {
        try {
            setGeneratingQR(true);
            const data = {
                sotien: values.amount
            };

            const response = await receiptAPIWithErrorHandling.generateQrcode(code, data);
            console.log('handleGenerateQR', response)

            // Cập nhật receiptData với QR code mới
            setReceipt(prev => ({
                ...prev,
                vietqr: response.data?.vietqr || response.data?.qrcode || response.data
            }));

            setAmount(values.amount);
            setShowAmountForm(false);
            message.success('Tạo mã QR thành công!');
        } catch (err) {
            message.error('Không thể tạo mã QR. Vui lòng thử lại!');
            console.error(err);
        } finally {
            setGeneratingQR(false);
        }
    };

    const handleReset = () => {
        setShowAmountForm(true);
        setAmount(null);
    };

    if (loading) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                <Spin size="large" />
            </div>
        );
    }

    if (error || !code) {
        return (
            <div
                style={{
                    backgroundColor: "#F8FAFC",
                    minHeight: "100vh",
                    padding: "10px",
                }}
            >
                <div className="receipt-wrapper print-area">
                    <div style={{ padding: "40px", textAlign: "center" }}>
                        <Alert
                            message="Không thể tải thông tin chiến dịch"
                            type="error"
                            showIcon
                        />
                    </div>
                </div>
            </div>
        );
    }

    if (!receiptData || receiptData.length === 0) {
        return (
            <div
                style={{
                    backgroundColor: "#F8FAFC",
                    minHeight: "100vh",
                    padding: "10px",
                }}
            >
                <div className="receipt-wrapper print-area">
                    <div style={{ padding: 40, textAlign: "center" }}>
                        <Alert
                            message="Vui lòng kiểm tra lại mã phiếu hoặc thử lại sau."
                            type="warning"
                            showIcon
                        />
                    </div>
                </div>
            </div>
        );
    }

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear(),
        };
    };

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('vi-VN', {
            style: 'currency',
            currency: 'VND'
        }).format(value);
    };

    const date = formatDate(receiptData.date);

    return (
        <div
            style={{
                backgroundColor: "#F8FAFC",
                minHeight: "100vh",
                padding: "10px",
            }}
        >
            <style>{`
            * {
            box-sizing: border-box;
            }

            .receipt-wrapper {
                background: white;
                border-radius: 8px;
                overflow: hidden;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            }

            .receipt-container {
                padding: 16px;
                max-width: 600px;
                margin: 0 auto;
                line-height: 1.5;
                font-size: 13px;
            }

            .header-section {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 16px;
                margin-bottom: 16px;
                padding-bottom: 12px;
                border-bottom: 2px solid #E2E8F0;
                font-size: 12px;
            }

            .header-left {
                text-align: left;
            }

            .header-right {
                text-align: right;
            }

            .header-label {
                font-weight: 600;
                margin-bottom: 4px;
                display: block;
                font-size: 11px;
            }

            .title-section {
                text-align: center;
                margin: 20px 0 16px 0;
            }

            .receipt-title {
                font-size: 22px;
                font-weight: 700;
                margin: 0 0 8px 0;
                letter-spacing: 0.5px;
            }

            .receipt-date {
                font-size: 12px;
                margin: 4px 0 2px 0;
                color: #333;
            }

            .receipt-number {
                font-size: 12px;
                color: #666;
            }

            .info-section {
                margin: 16px 0;
                background: #f9f9f9;
                padding: 12px;
                border-radius: 6px;
            }

            .info-item {
                margin: 10px 0;
                display: flex;
                justify-content: space-between;
            }

            .info-label {
                font-weight: 600;
                font-size: 12px;
                margin-bottom: 3px;
                color: #333;
            }

            .info-value {
                font-size: 13px;
                color: #555;
                word-break: break-word;
                line-height: 1.4;
            }

            .amount-highlight {
                background: #fff3cd;
                border-left: 4px solid #ff6b6b;
                padding: 10px 12px;
                margin: 12px 0;
                border-radius: 4px;
            }

            .amount-text {
                font-size: 12px;
                margin-top: 6px;
                color: #333;
            }

            .qr-section {
                text-align: center;
                margin: 16px 0;
                border: 1px dashed #CBD5E1;
                border-radius: 6px;
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            .qr-image {
                width: 100%;
                max-width: 180px;
                height: auto;
                border-radius: 4px;
            }

            .details-section {
                margin: 16px 0;
            }

            .details-title {
                font-weight: 600;
                font-size: 13px;
                margin-bottom: 10px;
                padding-bottom: 8px;
                border-bottom: 2px solid #E2E8F0;
            }

            .detail-row {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 8px 0;
                border-bottom: 1px solid #F1F5F9;
                font-size: 12px;
            }

            .detail-row:last-child {
                border-bottom: none;
            }

            .amount-form-section {
                background: #fff;
                padding: 24px;
                border-radius: 8px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                margin: 16px 0;
            }

            @media (max-width: 480px) {
            .receipt-container {
                padding: 12px;
                font-size: 12px;
            }

            .header-section {
                gap: 12px;
                margin-bottom: 12px;
                padding-bottom: 10px;
            }

            .header-label {
                font-size: 10px;
                margin-bottom: 3px;
            }

            .receipt-title {
                font-size: 18px;
                margin-bottom: 6px;
            }

            .receipt-date, .receipt-number {
                font-size: 11px;
            }

            .info-section {
                padding: 10px;
                margin: 12px 0;
            }

            .info-item {
                margin: 8px 0;
            }

            .info-label {
                font-size: 11px;
                margin-bottom: 2px;
            }

            .info-value {
                font-size: 12px;
            }

            .qr-image {
                max-width: 160px;
            }
            }

      `}</style>

            <div className="receipt-wrapper print-area">
                <div className="receipt-container">

                    {/* Title */}
                    <div className="title-section">
                        <div className="receipt-title">PHIẾU THU</div>
                        <div className="receipt-date">
                            Ngày {date.day} tháng {date.month} năm {date.year}
                        </div>
                        <div className="receipt-number">Số: {receiptData.receipt_no}</div>
                    </div>

                    {/* Info Section */}
                    <div className="info-section">
                        <div className="info-item">
                            <span className="info-label">Khách hàng:</span>
                            <span className="info-value">{receiptData.payer_name}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">Địa chỉ:</span>
                            <span className="info-value">{receiptData.address}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">Nội dung thu:</span>
                            <span className="info-value">
                                {receiptData.content_banking}
                            </span>
                        </div>
                        {amount && (
                            <div className="info-item" style={{ background: '#F0F6FD', padding: '8px', borderRadius: '4px', marginTop: '12px' }}>
                                <span className="info-label" style={{ color: '#0070D7' }}>Số tiền ủng hộ:</span>
                                <span className="info-value" style={{ fontWeight: 'bold', color: '#0070D7', fontSize: '15px' }}>
                                    {formatCurrency(amount)}
                                </span>
                            </div>
                        )}
                    </div>


                    {/* Amount Form */}
                    {showAmountForm && (
                        <div className="amount-form-section">
                            <Title level={5} style={{ textAlign: 'center', marginBottom: 20 }}>
                                Nhập số tiền ủng hộ
                            </Title>
                            <Form
                                onFinish={handleGenerateQR}
                                layout="vertical"
                            >
                                <Form.Item
                                    name="amount"
                                    label="Số tiền (VNĐ)"
                                    rules={[
                                        { required: true, message: 'Vui lòng nhập số tiền!' },
                                        {
                                            type: 'number',
                                            min: 1000,
                                            message: 'Số tiền tối thiểu 1.000 VNĐ'
                                        }
                                    ]}
                                >
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        placeholder="Nhập số tiền"
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        min={1000}
                                        step={10000}
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        block
                                        // size="small"
                                        loading={generatingQR}
                                        style={{
                                            backgroundColor: "#51aae9"
                                        }}
                                    >
                                        Tiếp tục
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    )}

                    {/* QR Code - Only show after generating */}
                    {!showAmountForm && (
                        <>
                            <div className="qr-section">
                                {receiptData?.vietqr ? (
                                    <div style={{ textAlign: 'center', padding: '12px 0' }}>
                                        <img
                                            src={receiptData?.vietqr ?? '#'}
                                            alt="QR thanh toán"
                                            style={{
                                                width: '100%',
                                                border: '1px solid #CBD5E1',
                                                borderRadius: 4
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <div style={{
                                        textAlign: 'center',
                                        padding: 40,
                                        background: '#F8FAFC',
                                        border: '1px dashed #CBD5E1',
                                        borderRadius: 4
                                    }}>
                                        <Text type="secondary">Không có mã QR</Text>
                                    </div>
                                )}

                                <Alert
                                    message={
                                        <div style={{ marginTop: 8, fontStyle: 'italic', fontSize: 13 }}>
                                            Mở ứng dụng ngân hàng &gt; Chọn quét mã QR &gt; Xác nhận chuyển khoản
                                        </div>
                                    }
                                    type="info"
                                />

                                <Button
                                    onClick={handleReset}
                                    style={{ marginTop: 12, marginBottom: 12 }}
                                    block
                                >
                                    Thay đổi số tiền
                                </Button>

                                {/* <div style={{ marginTop: 5 }}> */}
                                <a
                                    href={receiptData?.vietqr ?? '#'}
                                    download="qr-thanh-toan.png"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Button icon={<DownloadOutlined />} style={{ fontSize: '12px', width: '100%' }}>
                                        Tải QR Code
                                    </Button>
                                </a>
                                {/* </div> */}
                            </div>
                        </>
                    )}

                    {/* Details */}
                    <div className="details-section">
                        <div className="details-title">Thông tin chi tiết</div>
                        <div
                            dangerouslySetInnerHTML={{ __html: receiptData.content }}
                            style={{
                                lineHeight: 1.8,
                            }}
                        />
                    </div>

                    {/* Footer */}
                    <Card
                        style={{
                            marginTop: 16,
                            textAlign: "center",
                            background: "#F8FAFC",
                        }}
                    >
                        <HeartOutlined
                            style={{ fontSize: 32, color: "#0070D7", marginBottom: 12 }}
                        />
                        <Title level={5}>Cảm ơn sự đóng góp của bạn!</Title>
                        <Paragraph
                            type="secondary"
                            style={{ marginBottom: 0, fontSize: "14px" }}
                        >
                            Mỗi đóng góp đều có ý nghĩa và góp phần xây dựng cộng đồng tốt đẹp
                            hơn.
                        </Paragraph>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default CampainCustomer;